module.exports = __webpack_public_path__ + "static/media/sort.44476872.svg";